export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/b7f7b288dfea02dba26459a2a7b68aed.png";